import axiosInstance from 'helpers/axiosInstance';

export const logoutAccount: () => Promise<void> = () => {
  return axiosInstance
    .post('/accounts/logout')
    .then(response => response.data.account);
};
